/**
 * Cashier Config
 */

define(function(require, exports, module) {
    'use strict';

    var i18n = require('i18n');
    var utils = require('utils');
    var cashierConfig = require('portlets/cashier/cashier.config');
    var userValidation = require('modules/user/user.validation.config');

    /**
     * Represents cashier config for all methods or chosen type+method
     * @param {String} [aspect] - 'method.methodType' selector for method and method type; Both parts are optional
     * @returns Object
     */
    module.exports = function(aspect) {
        var coreConfig = cashierConfig(aspect);
        var userValidationConfig = userValidation();

        var basicValidation = {
            amount: {
                required: true,
                amount: {
                    message: i18n.t('playtech.mobile.system.mobile-cashier.amount.tooltip.format')
                },
                range: {
                    message: i18n.t('playtech.mobile.system.mobile-cashier.amount.tooltip.range')
                }
            },
            accountId: {
                required: true
            },
            cvv2: {
                required: true,
                length: {
                    min: 3,
                    max: 4,
                    message: i18n.t('playtech.mobile.system.mobile-cashier.error.cvv2.length')
                },
                regexp: {
                    regexp: /^$|^\d+$/,
                    message: i18n.t('playtech.mobile.system.mobile-cashier.error.cvv2.regexp')
                }
            }
        };

        if (aspect) {
            if (aspect.indexOf('InteracCombinedviaSC') >= 0) {
                coreConfig = {
                    isGeneric: true,
                    redirect: true,
                    validationConfig: utils.deepExtend({}, basicValidation, {
                        field2: userValidationConfig.registerEmail,
                        field3: userValidationConfig.phoneWithArea
                    })
                };
            }
        }

        return coreConfig;
    };
});
